module.exports = __webpack_public_path__ + "static/images/options-horizontal.aec4e7b34b1aa1ef5a00f848ea2741e1.svg";